module.exports = __webpack_public_path__ + "static/media/klimaschutz.4aaa5e9b.jpg";